import React, { useState } from 'react';

import { TabsBooking } from './TabsBooking';

import MyBooking from './MyBooking';

const MyBookingPage = () => {
  // Values: 0: vuelos, 1: alojamiento, 2: asistencia al viajero.
  const [searchType, setSearchType] = useState(1);
  const parentKey = `parent-${searchType}`;

  return (
    <div key={parentKey} className="minWebPadding">
      <TabsBooking value={searchType} setValue={setSearchType} />
      <MyBooking key={searchType} searchType={searchType} />
    </div>
  );
};

export default MyBookingPage;
